import { useMemo, useContext } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'antd'
import { EasyIcon, EditPropsContext, EditContext, ModalContext, LoadableButton } from 'src/components'
import { getValidBtns } from '../helper'
import { $consts } from 'src/plugins'

const EditPageBottom = () => {
  const editProps = useContext(EditPropsContext)
  const edit = useContext(EditContext)
  const modal = useContext(ModalContext)

  const formParams = useMemo(() => {
    return editProps?.formData?.formDisabled !== undefined ? { __READONLY__: editProps.formData.formDisabled } : {}
  }, [editProps?.formData?.formDisabled])

  const enableBtns = useMemo(() => {
    return getValidBtns(edit.editConfig.Nav_PageEdit?.Nav_Btns)
  }, [edit.editConfig.Nav_PageEdit?.Nav_Btns])

  const visible = useMemo(() => {
    return edit.editConfig.Nav_PageEdit?.Nav_PageEdit?.BTN_POSITION === $consts['EDIT/PAGE_BTN_LOCATE_BOTTOM']
  }, [edit.editConfig.Nav_PageEdit?.Nav_PageEdit?.BTN_POSITION])

  if (!visible) return null

  if (!enableBtns.length) return null

  return (
    <div className='edit-page__bottom'>
      {modal.initDone ? <Button icon={<EasyIcon type='CloseOutlined' />} onClick={() => modal.close()}>关闭</Button> : null}
      {
        enableBtns.map((btn: any, index: number) => (
          <LoadableButton
            key={`${btn.ID}_${index}`}
            pageType={$consts['TABLE/FORM_TYPE_EDIT_PAGE']}
            locateBtn={$consts['TABLE/BTN_LOCATE_PAGER']}
            config={Object.assign({}, btn, formParams)}
          />
        ))
      }
    </div>
  )
}

export default observer(EditPageBottom)